/*! @azure/msal-common v4.4.0 2021-06-29 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */

var TokenCacheContext = function () {
  function TokenCacheContext(tokenCache, hasChanged) {
    this.cache = tokenCache;
    this.hasChanged = hasChanged;
  }

  Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
    /**
     * boolean which indicates the changes in cache
     */
    get: function get() {
      return this.hasChanged;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
    /**
     * function to retrieve the token cache
     */
    get: function get() {
      return this.cache;
    },
    enumerable: false,
    configurable: true
  });
  return TokenCacheContext;
}();

export { TokenCacheContext };